import type { ElementSettings } from '../types';
import type { ActiveDataBinding } from '../../runtime/dataServices/types';

export type HorizontalAlignment = 'left' | 'center' | 'right';

export interface TableCellObjectSettings {
    value: string;
    rowSpan?: number;
    columnIndex?: number;
}

export type TableCellSettings = string | TableCellObjectSettings;

export interface TableLayoutRowSettings {
    cells: TableCellSettings[];
}

export interface TableRowSettings {
    cells: string[];
}

export interface TableBaseLayoutShape {
    header: string[];
    rows: TableRowSettings[];
    columnAlignments?: HorizontalAlignment[];
    columnWidths?: string[];
}

export interface TableLayoutShape extends Omit<TableBaseLayoutShape, 'rows'> {
    rows: TableLayoutRowSettings[];
}

export type TableBinding = ActiveDataBinding;

export interface TableSettings extends ElementSettings, TableBaseLayoutShape {
    title?: string;
    showWhenEmpty: boolean;
    binding: TableBinding | null;
    spacious?: boolean;
}

const DEFAULT_STATIC_TABLE_COLUMN_ALIGNMENTS: readonly HorizontalAlignment[] = ['left', 'left'];

function createIndexedLabel(label: string, index: number): string {
    return `${label} ${index}`;
}

export function createDefaultStaticTableSettings(): Pick<
    TableSettings,
    'title' | 'header' | 'rows' | 'columnAlignments' | 'binding' | 'showWhenEmpty'
> {
    return {
        showWhenEmpty: false,
        title: gettext('ELEMENT_TABLE_PRESET_DEFAULT_TITLE'),
        header: [
            createIndexedLabel(gettext('COLUMN'), 1),
            createIndexedLabel(gettext('COLUMN'), 2),
        ],
        rows: [
            {
                cells: [
                    createIndexedLabel(gettext('VALUE'), 1),
                    createIndexedLabel(gettext('VALUE'), 2),
                ],
            },
        ],
        columnAlignments: [...DEFAULT_STATIC_TABLE_COLUMN_ALIGNMENTS],
        binding: null,
    };
}
